import { create } from 'zustand';
import { ColumnState } from 'ag-grid-community';
import { MST1020_R01_BomDto, defaultBomData, MST1020_R01HeaderDto } from './Dto_MST1020_R01';
import { ItemDto } from 'src/dtos/item/itemDto';
import { showWarning } from 'src/utils/toast/toastUtil';

// 선택된 품목 정보 타입 (검색용)
export interface SelectedItemInfo {
	itemCd: string;
	itemNm: string;
}

export interface MST1020_R01Filter {
	searchText: string;
	searchTextNm: string;
	itemGroup: string;	
	itemAccount: string;
	bomUseyn: string;
}
export interface Store_MST1020_R01 {
	// ====== 검색 필터 ======
	MST1020_R01Filter: MST1020_R01Filter;
	MST1020_R01PastFilter: MST1020_R01Filter;
	setMST1020_R01Filter: (filter: Partial<MST1020_R01Filter>) => void;
	setMST1020_R01PastFilter: (filter: Partial<MST1020_R01Filter>) => void;

	// ====== 품목 리스트 및 선택 ======
	MST1020_R01ItemList: MST1020_R01HeaderDto[]; // 품목 목록 
	setMST1020_R01ItemList: (itemList: MST1020_R01HeaderDto[]) => void;

	selectedMST1020_R01Item: MST1020_R01HeaderDto | undefined; // 선택된 품목 
	setSelectedMST1020_R01Item: (data: MST1020_R01HeaderDto | undefined) => void;
	initSelectedMST1020_R01Item: () => void;

	// 검색 조건에서 선택된 품목 정보 (모달용)
	selectedItemInfo: SelectedItemInfo | undefined;
	setSelectedItemInfo: (itemInfo: SelectedItemInfo | undefined) => void;

	// ====== BOM 리스트 및 선택/편집 ======
	MST1020_R01BomList: MST1020_R01_BomDto[]; // Bom 리스트 
	setMST1020_R01BomList: (bomList: MST1020_R01_BomDto[]) => void;
	insertMST1020_R01BomList: (data: MST1020_R01_BomDto[], index?: number) => void;
	removeMST1020_R01Bom: (index: number) => void;
	updateMST1020_R01Bom: (index: number, updatedRow: MST1020_R01_BomDto) => void;

	selectedMST1020_R01BomDetail: MST1020_R01_BomDto | undefined; // 선택된 BOM 
	setSelectedMST1020_R01BomDetail: (data: MST1020_R01_BomDto | undefined) => void;
	initSelectedMST1020_R01BomDetail: () => void;

	// ====== BOM 상세 행 선택/삭제 관리 ======
	deletedMST1020_R01BomDetailList: string[]; // 삭제된 BOM 리스트 
	addDeletedMST1020_R01BomDetailList: (idList: string[]) => void;
	removeDeletedMST1020_R01BomDetailList: (idList?: string[]) => void;
	
	selectedMST1020_R01BomDetailList: string[]; // 선택된 BOM 상세 리스트 
	setSelectedMST1020_R01BomDetailList: (idList: string[]) => void; // 선택된 BOM 상세 리스트 설정 (MST1020 전용)
	addSelectedMST1020_R01BomDetailList: (idList: string[]) => void; // 선택된 BOM 상세 리스트 추가 
	removeSelectedMST1020_R01BomDetailList: (idList?: string[]) => void; // 선택된 BOM 상세 리스트 제거 
	initSelectedMST1020_R01BomDetailList: () => void; // 선택된 BOM 상세 리스트 초기화 
	allSelectedMST1020_R01BomDetailList: () => void; // 선택된 BOM 상세 리스트 전체 선택 

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;		setColumnState: (state: ColumnState[] | null) => void;
	bomColumnState: ColumnState[] | null;		setBomColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;

	originalMST1020_R01BomList: MST1020_R01_BomDto[];
	setOriginalMST1020_R01BomList: (list: MST1020_R01_BomDto[]) => void;

	allCount: number;				setAllCount: (allCount: number) => void;
	detailFetchTrigger: boolean;	setDetailFetchTrigger: (trigger: boolean) => void;
	

	// ====== 초기화 ======
	initData: () => void;
}


export interface Store_MST1020_R01_GridCalendarState {

	// ====== MST1020_R01 GridCalendar 상태 ======
	MST1020_R01GridCalendarState: {
		pickerVisible: boolean;
		pickerPosition: { top: number; left: number };
		targetRowIndex: number | null;
		targetField: string | null;
		targetDate: Date | undefined;
	};
	setMST1020_R01GridCalendarState: (state: Partial<Store_MST1020_R01_GridCalendarState['MST1020_R01GridCalendarState']>) => void;
	initMST1020_R01GridCalendarState: () => void;

}

export const defaultMST1020_R01Filter : MST1020_R01Filter = {
	searchText: '',
	searchTextNm: '',
	itemGroup: '',
	itemAccount: '',
	bomUseyn: 'Y'
};

export const useMST1020_R01Store = create<Store_MST1020_R01>((set) => ({
	// ====== 검색 필터 ======
	MST1020_R01Filter: defaultMST1020_R01Filter,
	MST1020_R01PastFilter: defaultMST1020_R01Filter,
	setMST1020_R01Filter: (filter: Partial<MST1020_R01Filter>) => set((state) => ({
		...state,
		MST1020_R01Filter: { ...state.MST1020_R01Filter, ...filter }
	})),
	setMST1020_R01PastFilter: (filter: Partial<MST1020_R01Filter>) => set((state) => ({
		...state,
		MST1020_R01PastFilter: { ...state.MST1020_R01PastFilter, ...filter }
	})),

	// ====== 품목 리스트 및 선택 ======
	MST1020_R01ItemList: [],
	setMST1020_R01ItemList: (itemList: MST1020_R01HeaderDto[]) => set((state) => ({
		...state,
		MST1020_R01ItemList: itemList
	})),

	selectedMST1020_R01Item: undefined,
	// 품목 변경 시 BOM 관련 상태 초기화
	setSelectedMST1020_R01Item: (data) => set((state) => {
		return { 
			selectedMST1020_R01Item: data,
			// 품목 변경 시 BOM 관련 상태 초기화
			MST1020_R01BomList: [],
			selectedMST1020_R01Bom: undefined,
			editMST1020_R01Bom: null,
			deletedMST1020_R01BomList: [],
			selectedMST1020_R01BomDetailList: [],
			detailFetchTrigger: true
		};
	}),
	initSelectedMST1020_R01Item: () => set({ selectedMST1020_R01Item: undefined, MST1020_R01BomList: [], detailFetchTrigger: false }),

	// 검색 조건에서 선택된 품목 정보 (모달용)
	selectedItemInfo: undefined,
	setSelectedItemInfo: (itemInfo) => set({ selectedItemInfo: itemInfo }),

	// ====== BOM 리스트 및 선택/편집 ======
	MST1020_R01BomList: [],
	setMST1020_R01BomList: (bomList: MST1020_R01_BomDto[]) => set((state) => {
		let newList: MST1020_R01_BomDto[] = [];
		let valueAndOrderIndex = 1;
		bomList.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				...defaultBomData,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			MST1020_R01BomList: newList
		}
	}),
	insertMST1020_R01BomList: (data: MST1020_R01_BomDto[], index?: number) => set((state) => {
		let newMST1020_R01BomList = [...state.MST1020_R01BomList];

		let targetRowData = newMST1020_R01BomList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newMST1020_R01BomList.map(item => item.valueIndex || 0)) + 1;

		// newMST1020_R01BomList에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newMST1020_R01BomList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newMST1020_R01BomList에 대체
		newMST1020_R01BomList = newMST1020_R01BomList.filter(item => item.orderIndex !== targetOrderIndex);
		newMST1020_R01BomList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultBomData, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newMST1020_R01BomList.splice(index, 0, ...newData);
		} else {
			newMST1020_R01BomList.push(...newData);
		}
		
		return {
			...state,
			MST1020_R01BomList: newMST1020_R01BomList
		}
	}),

	removeMST1020_R01Bom: (index: number) => set((state) => {
		const newMST1020_R01BomList = [...state.MST1020_R01BomList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			MST1020_R01BomList: newMST1020_R01BomList
		}
	}),
	updateMST1020_R01Bom: (index: number, updatedRow: MST1020_R01_BomDto) => set((state) => {
		const _MST1020_R01BomList = state.MST1020_R01BomList.map(item =>
			item.valueIndex === index ? updatedRow : item
		);
		// if(updatedRow.bomSeq < 1) {
		// 	showWarning('순서는 1보다 작을 수 없습니다.');
		// 	updatedRow.bomSeq = 1;
		// }
		if(updatedRow.prntItemQty < 0) {
			showWarning('모품목수량은 0보다 작을 수 없습니다.');
			updatedRow.prntItemQty = 0;
		}
		if(updatedRow.childItemUsage < 0) {
			showWarning('소요량은 0보다 작을 수 없습니다.');
			updatedRow.childItemUsage = 0;
		}
		if(updatedRow.lossPercent < 0) {
			showWarning('손실율은 0보다 작을 수 없습니다.');
			updatedRow.lossPercent = 0;
		}
		if(updatedRow.lossPercent > 100) {
			showWarning('손실율은 100%를 초과할 수 없습니다.');
			updatedRow.lossPercent = 100;
		}
		return {
			...state,
			MST1020_R01BomList: _MST1020_R01BomList
		}
	}),

	selectedMST1020_R01BomDetail: undefined,
	setSelectedMST1020_R01BomDetail: (data: MST1020_R01_BomDto | undefined) => set((state) => {
		return { selectedMST1020_R01BomDetail: data, editMST1020_R01Bom: data ? { ...data } : null };
	}),
	initSelectedMST1020_R01BomDetail: () => set({ selectedMST1020_R01BomDetail: undefined }),

	// ====== BOM 상세 행 삭제 관리 ======
	deletedMST1020_R01BomDetailList: [],
	addDeletedMST1020_R01BomDetailList: (idList: string[]) => set((state) => {
		const _deletedBomDetailList = [...state.deletedMST1020_R01BomDetailList];
		for(const valueIndex of idList) {
			const isInserted = state.MST1020_R01BomList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.MST1020_R01BomList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedBomDetailList.push(valueIndex);
			}
		}
		return { ...state, deletedMST1020_R01BomDetailList: _deletedBomDetailList };
	}),
	removeDeletedMST1020_R01BomDetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedMST1020_R01BomDetailList: state.deletedMST1020_R01BomDetailList.filter(value => idList ? !idList.includes(value) : false),
	})),

	// ====== BOM 상세 행 선택 관리 ======  
	selectedMST1020_R01BomDetailList: [],
	setSelectedMST1020_R01BomDetailList: (idList: string[]) => set({ selectedMST1020_R01BomDetailList: idList }),
	addSelectedMST1020_R01BomDetailList: (idList: string[]) => set((state) => {
		const _selectedMST1020_R01BomDetailList = [...state.selectedMST1020_R01BomDetailList];
		if(idList.length > 0) {
			_selectedMST1020_R01BomDetailList.push(...idList);
		}
		return {
			...state,
			selectedMST1020_R01BomDetailList: _selectedMST1020_R01BomDetailList
		}
	}),
	removeSelectedMST1020_R01BomDetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedMST1020_R01BomDetailList: state.selectedMST1020_R01BomDetailList.filter(value => idList ? !idList.includes(value) : false),
	})),
	initSelectedMST1020_R01BomDetailList: () => set({ selectedMST1020_R01BomDetailList: [] }),
	allSelectedMST1020_R01BomDetailList: () => set((state) => {
		const _selectedMST1020_R01BomDetailList = [...state.MST1020_R01BomList.map(item => item.valueIndex.toString())];
		return {
			...state,
			selectedMST1020_R01BomDetailList: _selectedMST1020_R01BomDetailList
		}
	}),

	// ====== 컬럼 상태(그리드) ======
	columnState: null,				setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	bomColumnState: null,			setBomColumnState: (state: ColumnState[] | null) => set({ bomColumnState: state }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),

	originalMST1020_R01BomList: [],
	setOriginalMST1020_R01BomList: (list: MST1020_R01_BomDto[]) => set((state) => {
		let newList: MST1020_R01_BomDto[] = [];
		let valueAndOrderIndex = 1;
		list.forEach((item, index) => {
			newList.push({ 
				...defaultBomData,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalMST1020_R01BomList: newList
		}
	}),

	// ====== 초기화 ======
	allCount: 0,
	setAllCount: (allCount: number) => set({ allCount }),

	detailFetchTrigger: false,
	setDetailFetchTrigger: (trigger: boolean) => set({ detailFetchTrigger: trigger }),
	

	initData: () => set(() => ({
		MST1020_R01Filter: defaultMST1020_R01Filter,
		MST1020_R01PastFilter: defaultMST1020_R01Filter,
		MST1020_R01ItemList: [],
		selectedMST1020_R01Item: undefined,
		selectedItemInfo: undefined,
		MST1020_R01BomList: [],
		selectedMST1020_R01Bom: undefined,
		editMST1020_R01Bom: null,
		deletedMST1020_R01BomList: [],
		selectedMST1020_R01BomDetailList: [],
		itemColumnState: null,
		bomColumnState: null,
		allCount: 0,

		detailFetchTrigger: false,
		scrollTop: null,
		detailScrollTop: null,

		MST1020_R01GridCalendarState: {
			pickerVisible: false,
			pickerPosition: { top: 0, left: 0 },
			targetRowIndex: null,
			targetField: null,
			targetDate: undefined
		}
	})),
})); 


export const useMST1020_R01Store_GridCalendar = create<Store_MST1020_R01_GridCalendarState>((set) => ({

	// ====== GridCalendar 상태 ======
	MST1020_R01GridCalendarState: {
		pickerVisible: false,
		pickerPosition: { top: 0, left: 0 },
		targetRowIndex: null,
		targetField: null,
		targetDate: undefined
	},
	setMST1020_R01GridCalendarState: (newState: Partial<Store_MST1020_R01_GridCalendarState['MST1020_R01GridCalendarState']>) => set((state) => ({
		...state,
		MST1020_R01GridCalendarState: { ...state.MST1020_R01GridCalendarState, ...newState }
	})),
	initMST1020_R01GridCalendarState: () => set((state) => ({
		...state,
		MST1020_R01GridCalendarState: {
			pickerVisible: false,
			pickerPosition: { top: 0, left: 0 },
			targetRowIndex: null,
			targetField: null,
			targetDate: undefined
		}
	})),


})); 